export default "__VITE_ASSET__16aa3184__"